import { useCallback, useState } from "react";

const STORAGE_KEY = "psychassist_current_score";

export interface EREvent {
  eventType: "breathing" | "decay_reset";
  triggerText: string | null;
  penalty: number;
  scoreBefore: number;
  scoreAfter: number;
  decayWindowMinutes: number | null;
}

export interface UseERScoringOptions {
  onEvent?: (event: EREvent) => void;
}

function persistScore(score: number) {
  try {
    localStorage.setItem(STORAGE_KEY, String(score));
  } catch {
    /* localStorage may be unavailable */
  }
}

export function useERScoring(_options?: UseERScoringOptions) {
  const [score, setScore] = useState(0);

  const processTranscript = useCallback((_text: string): void => {
    // PsychAssist no longer derives ER from verbal content.
  }, []);

  const reset = useCallback(() => {
    setScore(0);
    persistScore(0);
    window.dispatchEvent(
      new CustomEvent("psychassist:score", {
        detail: { score: 0, timestamp: Date.now() },
      }),
    );
  }, []);

  return {
    score,
    eventCount: 0,
    lastTriggerAt: null,
    decayWindowMinutes: 0,
    processTranscript,
    reset,
  };
}
